export default {
    key: 'guided-tour',
    common: {
        productName: 'core.productNames.guided-tour',
        splashMessage: 'offerFlow.splashMessage.guided-tour',
        headingAside: 'offerFlow.headingAside.guided-tour',
    },
    stepActivitySelection: {
        heading: 'offerFlow.pages.stepActivitySelection.heading.guided-tour',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.guided-tour',
    },
    stepActivityOptions: {
        heading: 'offerFlow.pages.stepActivityOptions.heading.common',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.activity',
        body: 'offerFlow.pages.stepPassengers.body.common',
    },
} satisfies OfferFlowContent;
